<template>
  <div class="security-page">
    <!-- 顶部导航 -->
    <div class="security-header">
      <div class="header-back" @click="$router.back()">
        <svg viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="none" stroke="#fff" stroke-width="2">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </div>
      <div class="header-title">{{ pageTitle }}</div>
      <div class="header-placeholder"></div>
    </div>

    <!-- 安全中心列表（无active参数时显示） -->
    <div class="security-list" v-if="active === -1">
      <div class="list-item">
        <div class="item-left">
          <svg class="item-icon" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#999">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
          </svg>
          <span class="item-name">会员账号</span>
        </div>
        <div class="item-right">
          <span class="item-value">{{ userInfo.username || '-' }}</span>
          <svg class="copy-icon" @click="copyUsername" viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="none" stroke="#d1ae52" stroke-width="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
          </svg>
        </div>
      </div>

      <div class="list-item" @click="goTo(0)">
        <div class="item-left">
          <svg class="item-icon" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#d1ae52">
            <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
          </svg>
          <span class="item-name">手机</span>
          <span class="red-dot" v-if="!userInfo.mobile"></span>
        </div>
        <div class="item-right">
          <span class="item-status" v-if="userInfo.mobile">{{ userInfo.mobile }}</span>
          <span class="item-status" v-else>未添加</span>
          <svg class="arrow-icon" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#666" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
      </div>

      <div class="list-item" @click="goTo(1)">
        <div class="item-left">
          <svg class="item-icon" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#999">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
          </svg>
          <span class="item-name">邮箱</span>
          <span class="red-dot" v-if="!userInfo.email"></span>
        </div>
        <div class="item-right">
          <span class="item-status" v-if="userInfo.email">{{ userInfo.email }}</span>
          <span class="item-status" v-else>未添加</span>
          <svg class="arrow-icon" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#666" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
      </div>

      <div class="list-item list-item-gap" @click="goTo(2)">
        <div class="item-left">
          <div class="icon-circle">
            <svg viewBox="0 0 100 100" width="0.5rem" height="0.5rem">
              <circle cx="50" cy="50" r="48" fill="#fff"/>
              <line x1="50" y1="50" x2="50" y2="12" stroke="#EA4335" stroke-width="12" stroke-linecap="round"/>
              <line x1="50" y1="50" x2="83" y2="31" stroke="#FBBC05" stroke-width="12" stroke-linecap="round"/>
              <line x1="50" y1="50" x2="83" y2="69" stroke="#34A853" stroke-width="12" stroke-linecap="round"/>
              <line x1="50" y1="50" x2="50" y2="88" stroke="#4285F4" stroke-width="12" stroke-linecap="round"/>
              <line x1="50" y1="50" x2="17" y2="69" stroke="#EA4335" stroke-width="12" stroke-linecap="round"/>
              <line x1="50" y1="50" x2="17" y2="31" stroke="#4285F4" stroke-width="12" stroke-linecap="round"/>
            </svg>
          </div>
          <span class="item-name">Google验证器</span>
          <span class="red-dot"></span>
        </div>
        <div class="item-right">
          <span class="item-status">未绑定</span>
          <svg class="arrow-icon" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#666" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
      </div>

      <div class="list-item" @click="goTo(3)">
        <div class="item-left">
          <svg class="item-icon" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#00e676">
            <path d="M15.5 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM12 9l-6 6v3h2v-2h1v2h2v-3l3-3z"/>
          </svg>
          <span class="item-name">登录密码</span>
        </div>
        <div class="item-right">
          <svg class="arrow-icon" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#666" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
      </div>

      <div class="list-item" @click="goTo(5)">
        <div class="item-left">
          <svg class="item-icon" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#ff5252">
            <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
          </svg>
          <span class="item-name">提现密码</span>
          <span class="red-dot" v-if="!userInfo.has_paypwd"></span>
        </div>
        <div class="item-right">
          <span class="item-status" :class="{ 'status-active': userInfo.has_paypwd }" v-if="userInfo.has_paypwd">已设置</span>
          <span class="item-status" v-else>未设置</span>
          <svg class="arrow-icon" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#666" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
      </div>

      <div class="list-item" @click="goTo(6)">
        <div class="item-left">
          <svg class="item-icon" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#00e676">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
          </svg>
          <span class="item-name">密保问题</span>
          <span class="red-dot" v-if="!userInfo.has_security_question"></span>
        </div>
        <div class="item-right">
          <span class="item-status" :class="{ 'status-active': userInfo.has_security_question }" v-if="userInfo.has_security_question">已设置</span>
          <span class="item-status" v-else>未设置</span>
          <svg class="arrow-icon" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#666" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- 手机 active=0 -->
    <div class="tab-content" v-if="active === 0">
      <div class="security-form">
        <div class="form-item">
          <span class="form-label">手机号</span>
          <input type="tel" class="form-input" v-model="phoneInput" placeholder="请输入手机号" maxlength="11" />
        </div>
        <div class="form-item">
          <span class="form-label">验证码</span>
          <div class="input-row">
            <input type="text" class="form-input input-flex" v-model="phoneCode" placeholder="请输入验证码" maxlength="6" />
            <button class="code-btn" :disabled="codeSending" @click="sendCode">{{ codeBtnText }}</button>
          </div>
        </div>
      </div>
      <div class="bottom-btn" @click="handleSubmit">确 定</div>
    </div>

    <!-- 邮箱 active=1 -->
    <div class="tab-content" v-if="active === 1">
      <div class="security-form">
        <div class="form-item">
          <span class="form-label">邮箱</span>
          <input type="email" class="form-input" placeholder="请输入邮箱地址" />
        </div>
        <div class="form-item">
          <span class="form-label">验证码</span>
          <div class="input-row">
            <input type="text" class="form-input input-flex" placeholder="请输入验证码" />
            <button class="code-btn">获取验证码</button>
          </div>
        </div>
      </div>
      <div class="bottom-btn" @click="handleSubmit">确 定</div>
    </div>

    <!-- 验证器 active=2 -->
    <div class="tab-content" v-if="active === 2">
      <div class="security-form">
        <div class="form-item">
          <span class="form-label">验证器密钥</span>
          <input type="text" class="form-input" placeholder="请输入验证器密钥" />
        </div>
        <div class="form-item">
          <span class="form-label">验证码</span>
          <input type="text" class="form-input" placeholder="请输入验证码" />
        </div>
      </div>
      <div class="bottom-btn" @click="handleSubmit">确 定</div>
    </div>

    <!-- 登录密码 active=3 -->
    <div class="tab-content" v-if="active === 3">
      <div class="security-form">
        <!-- 原登录密码（暂时注释，后期增加新接口后恢复）
        <div class="form-item">
          <span class="form-label">原登录密码</span>
          <div class="input-with-icon">
            <svg class="key-icon" viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="#666">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
            </svg>
            <input :type="showOldPwd ? 'text' : 'password'" class="form-input with-icon" v-model="oldPwd" placeholder="请输入原密码" />
            <div class="eye-icon" @click="showOldPwd = !showOldPwd">
              <svg v-if="!showOldPwd" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#999">
                <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28-2.28 14.14 14.14-2.28 2.28-3.39-3.39c-1.1.49-2.32.76-3.6.76-4.28 0-8.28-3.13-11-7.5.89-1.44 2.16-2.67 3.67-3.54L2 4.27zM9.9 4.24C9.42 4.09 8.92 4 8.4 4 3.97 4 .83 7.11 1 11.46c.44.96 1.11 1.84 1.96 2.59L9.9 4.24zM14.88 11.14L9.26 5.52c-.15.15-.3.32-.44.5C8.51 6.59 8 7.57 8 8.65c0 2.76 2.24 5 5 5 .37 0 .74-.05 1.09-.16.18-.07.36-.14.53-.24l-.74-.74"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#d1ae52">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
              </svg>
            </div>
          </div>
        </div>
        -->
        <div class="form-item">
          <span class="form-label">修改登录密码</span>
          <div class="input-with-icon">
            <svg class="key-icon" viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="#666">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
            </svg>
            <input :type="showNewPwd ? 'text' : 'password'" class="form-input with-icon" v-model="newPwd" placeholder="请输入新登录密码" />
            <div class="eye-icon" @click="showNewPwd = !showNewPwd">
              <svg v-if="!showNewPwd" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#999">
                <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28-2.28 14.14 14.14-2.28 2.28-3.39-3.39c-1.1.49-2.32.76-3.6.76-4.28 0-8.28-3.13-11-7.5.89-1.44 2.16-2.67 3.67-3.54L2 4.27zM9.9 4.24C9.42 4.09 8.92 4 8.4 4 3.97 4 .83 7.11 1 11.46c.44.96 1.11 1.84 1.96 2.59L9.9 4.24zM14.88 11.14L9.26 5.52c-.15.15-.3.32-.44.5C8.51 6.59 8 7.57 8 8.65c0 2.76 2.24 5 5 5 .37 0 .74-.05 1.09-.16.18-.07.36-.14.53-.24l-.74-.74"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#d1ae52">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
              </svg>
            </div>
          </div>
          <!-- 密码强度提示 -->
          <div class="pwd-strength">
            <span class="strength-label">密码强度</span>
            <div class="strength-bar">
              <div class="strength-item" :class="{ active: hasLowercase }"></div>
              <div class="strength-item" :class="{ active: hasUppercase }"></div>
              <div class="strength-item" :class="{ active: hasNumber }"></div>
              <div class="strength-item" :class="{ active: hasLength }"></div>
            </div>
            <span class="strength-label">6-16位</span>
            <div class="strength-tips">
              <span class="tip" :class="{ pass: hasUppercase }">大写字母</span>
              <span class="tip" :class="{ pass: hasLowercase }">小写字母</span>
              <span class="tip" :class="{ pass: hasNumber }">数字</span>
            </div>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label">二次确认新密码</span>
          <div class="input-with-icon">
            <svg class="key-icon" viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="#666">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
            </svg>
            <input :type="showConfirmPwd ? 'text' : 'password'" class="form-input with-icon" v-model="confirmPwd" placeholder="请再次输入新登录密码" />
            <div class="eye-icon" @click="showConfirmPwd = !showConfirmPwd">
              <svg v-if="!showConfirmPwd" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#999">
                <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28-2.28 14.14 14.14-2.28 2.28-3.39-3.39c-1.1.49-2.32.76-3.6.76-4.28 0-8.28-3.13-11-7.5.89-1.44 2.16-2.67 3.67-3.54L2 4.27zM9.9 4.24C9.42 4.09 8.92 4 8.4 4 3.97 4 .83 7.11 1 11.46c.44.96 1.11 1.84 1.96 2.59L9.9 4.24zM14.88 11.14L9.26 5.52c-.15.15-.3.32-.44.5C8.51 6.59 8 7.57 8 8.65c0 2.76 2.24 5 5 5 .37 0 .74-.05 1.09-.16.18-.07.36-.14.53-.24l-.74-.74"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#d1ae52">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-btn" @click="handleSubmit">确 定</div>
    </div>

    <!-- 绑定手机 active=4 -->
    <div class="tab-content" v-if="active === 4">
      <div class="security-form">
        <div class="form-item">
          <span class="form-label">手机号</span>
          <input type="tel" class="form-input" placeholder="请输入手机号" />
        </div>
        <div class="form-item">
          <span class="form-label">验证码</span>
          <input type="text" class="form-input" placeholder="请输入验证码" />
          <button class="code-btn">获取验证码</button>
        </div>
      </div>
      <div class="bottom-btn" @click="handleSubmit">确 定</div>
    </div>

    <!-- 提现密码 active=5 -->
    <div class="tab-content" v-if="active === 5">
      <div class="security-tip-text">为了资金安全，需先设置提现密码哦！</div>
      <div class="security-form">
        <div class="form-item-row">
          <span class="form-label">{{ userInfo.has_paypwd ? '修改提现密码' : '设置提现密码' }}</span>
          <div class="pwd-eye-icon" @click.stop="showPwd1 = !showPwd1">
            <svg v-if="!showPwd1" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#999">
              <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28-2.28 14.14 14.14-2.28 2.28-3.39-3.39c-1.1.49-2.32.76-3.6.76-4.28 0-8.28-3.13-11-7.5.89-1.44 2.16-2.67 3.67-3.54L2 4.27zM9.9 4.24C9.42 4.09 8.92 4 8.4 4 3.97 4 .83 7.11 1 11.46c.44.96 1.11 1.84 1.96 2.59L9.9 4.24zM14.88 11.14L9.26 5.52c-.15.15-.3.32-.44.5C8.51 6.59 8 7.57 8 8.65c0 2.76 2.24 5 5 5 .37 0 .74-.05 1.09-.16.18-.07.36-.14.53-.24l-.74-.74"/>
            </svg>
            <svg v-else viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#d1ae52">
              <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
            </svg>
          </div>
        </div>
        <div class="pwd-inputs" @click.stop="focusPwd(1)">
          <div
            v-for="i in 6"
            :key="'p1-' + i"
            class="pwd-box"
            :class="{ active: keyboardVisible && currentField === 1 && (pwd1.length < 6 ? i === pwd1.length + 1 : i === 6) }"
          >
            <span v-if="pwd1.length >= i" :class="{ dot: !showPwd1 }">{{ showPwd1 ? pwd1[i - 1] : '' }}</span>
          </div>
        </div>
        <div class="warning-text" v-if="warningMsg">
          <span class="warning-icon">!</span>
          {{ warningMsg }}
        </div>
        <div class="form-item-row">
          <span class="form-label">确认提现密码</span>
          <div class="pwd-eye-icon" @click.stop="showPwd2 = !showPwd2">
            <svg v-if="!showPwd2" viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#999">
              <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28-2.28 14.14 14.14-2.28 2.28-3.39-3.39c-1.1.49-2.32.76-3.6.76-4.28 0-8.28-3.13-11-7.5.89-1.44 2.16-2.67 3.67-3.54L2 4.27zM9.9 4.24C9.42 4.09 8.92 4 8.4 4 3.97 4 .83 7.11 1 11.46c.44.96 1.11 1.84 1.96 2.59L9.9 4.24zM14.88 11.14L9.26 5.52c-.15.15-.3.32-.44.5C8.51 6.59 8 7.57 8 8.65c0 2.76 2.24 5 5 5 .37 0 .74-.05 1.09-.16.18-.07.36-.14.53-.24l-.74-.74"/>
            </svg>
            <svg v-else viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="#d1ae52">
              <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
            </svg>
          </div>
        </div>
        <div class="pwd-inputs" @click.stop="focusPwd(2)">
          <div
            v-for="i in 6"
            :key="'p2-' + i"
            class="pwd-box"
            :class="{ active: keyboardVisible && currentField === 2 && (pwd2.length < 6 ? i === pwd2.length + 1 : i === 6) }"
          >
            <span v-if="pwd2.length >= i" :class="{ dot: !showPwd2 }">{{ showPwd2 ? pwd2[i - 1] : '' }}</span>
          </div>
        </div>
      </div>
      <div class="warning-text">
        <span class="warning-icon">!</span>
        注意：提现密码保护您的资金安全，非常重要，只能自己知道，以免造成资金损失
      </div>
      <div class="bottom-btn" @click="handleSubmit">确 定</div>
    </div>

    <!-- 数字键盘弹框 -->
    <div class="keyboard-overlay" v-if="keyboardVisible">
      <div class="keyboard-collapse-area" @click="keyboardVisible = false"></div>
      <div class="keyboard-popup" @click.stop>
        <div class="keyboard-body">
          <div class="keyboard-row">
            <div class="keyboard-key" v-for="n in [1,2,3]" :key="n" @click="onKey(n)">{{ n }}</div>
          </div>
          <div class="keyboard-row">
            <div class="keyboard-key" v-for="n in [4,5,6]" :key="n" @click="onKey(n)">{{ n }}</div>
          </div>
          <div class="keyboard-row">
            <div class="keyboard-key" v-for="n in [7,8,9]" :key="n" @click="onKey(n)">{{ n }}</div>
          </div>
          <div class="keyboard-row">
            <div class="keyboard-key keyboard-hide" @click="keyboardVisible = false">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <rect x="2" y="6" width="20" height="12" rx="2" fill="none" stroke="#fff" stroke-width="1.5"/>
                <line x1="6" y1="10" x2="6" y2="10" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                <line x1="10" y1="10" x2="10" y2="10" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                <line x1="14" y1="10" x2="14" y2="10" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                <line x1="18" y1="10" x2="18" y2="10" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                <line x1="7" y1="14" x2="17" y2="14" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="keyboard-key" @click="onKey(0)">0</div>
            <div class="keyboard-key keyboard-delete" @click="onBackspace">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path d="M22 3H7l-5 9 5 9h15V3z" fill="none" stroke="#fff" stroke-width="1.5"/>
                <line x1="14" y1="9" x2="18" y2="15" stroke="#fff" stroke-width="1.5"/>
                <line x1="18" y1="9" x2="14" y2="15" stroke="#fff" stroke-width="1.5"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 密保问题 active=6 -->
    <div class="tab-content" v-if="active === 6">
      <div class="security-form">
        <div class="form-item">
          <span class="form-label">设置密保问题</span>
        </div>
        <div class="select-wrapper" :class="{ open: questionOpen }">
          <div class="select-trigger" @click="questionOpen = !questionOpen">
            <svg viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="#999">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15v-4H8l4-7v4h3l-4 7z"/>
            </svg>
            <span class="select-text">{{ selectedQuestion || '请选择密保问题' }}</span>
            <svg class="select-arrow" :class="{ rotate: questionOpen }" viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#999" stroke-width="2">
              <path d="M6 9l6 6 6-6"/>
            </svg>
          </div>
          <div class="select-dropdown" v-if="questionOpen">
            <div
              v-for="(q, idx) in questions"
              :key="idx"
              class="select-option"
              :class="{ active: selectedQuestion === q }"
              @click="selectedQuestion = q; questionOpen = false"
            >
              {{ idx + 1 }}. {{ q }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="input-with-icon">
            <svg class="key-icon" viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="#999">
              <path d="M12.65 10a6 6 0 1 0-1.3 0H7v4h4v-4h1.65zM18 14v-4h-2v4h-2v2h6v-2h-2z"/>
            </svg>
            <input type="text" class="form-input with-icon" v-model="securityAnswer" placeholder="请输入密保答案" />
          </div>
        </div>
        <div class="form-item">
          <div class="input-with-icon">
            <svg class="key-icon" viewBox="0 0 24 24" width="0.35rem" height="0.35rem" fill="#999">
              <path d="M12.65 10a6 6 0 1 0-1.3 0H7v4h4v-4h1.65zM18 14v-4h-2v4h-2v2h6v-2h-2z"/>
            </svg>
            <input type="text" class="form-input with-icon" v-model="securityAnswerConfirm" placeholder="请再次输入密保答案" />
          </div>
        </div>
      </div>
      <div class="bottom-btn" @click="handleSubmit">确 定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Security',
  data() {
    return {
      active: -1,
      pwd1: [],
      pwd2: [],
      showPwd1: false,
      showPwd2: false,
      keyboardVisible: false,
      currentField: 1,
      warningMsg: '',
      questionOpen: false,
      selectedQuestion: '',
      questions: [
        '你爸爸叫什么名字？',
        '你妈妈叫什么名字？',
        '你的手机号是多少？',
        '你老婆叫什么名字？',
        '你女朋友叫什么名字？',
        '你是哪里人？',
        '世界上最靓仔的人叫什么名字？'
      ],
      userInfo: {
        username: '',
        mobile: '',
        email: '',
        has_paypwd: false,
        has_security_question: false
      },
      // 登录密码相关
      oldPwd: '',
      newPwd: '',
      confirmPwd: '',
      showOldPwd: false,
      showNewPwd: false,
      showConfirmPwd: false,
      securityAnswer: '',
      securityAnswerConfirm: '',
      // 手机绑定相关
      phoneInput: '',
      phoneCode: '',
      codeSending: false,
      codeBtnText: '获取验证码',
      codeTimer: null,
      codeCountdown: 0
    }
  },
  computed: {
    pageTitle() {
      const titles = ['手机', '邮箱', '验证器', '登录密码', '绑定手机', '提现密码', '密保问题']
      return this.active >= 0 ? titles[this.active] : '安全中心'
    },
    hasLowercase() {
      return /[a-z]/.test(this.newPwd);
    },
    hasUppercase() {
      return /[A-Z]/.test(this.newPwd);
    },
    hasNumber() {
      return /[0-9]/.test(this.newPwd);
    },
    hasLength() {
      return this.newPwd.length >= 6 && this.newPwd.length <= 16;
    }
  },
  created() {
    this.updateActive()
    this.loadUserInfo()
  },
  watch: {
    '$route.query.active'() {
      this.updateActive()
    }
  },
  methods: {
    updateActive() {
      const a = this.$route.query.active
      this.active = a !== undefined && a !== '' ? parseInt(a) : -1
    },
    loadUserInfo() {
      this.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200 && res.data) {
          this.userInfo = {
            username: res.data.username || '',
            mobile: res.data.mobile || '',
            email: res.data.email || '',
            has_paypwd: res.data.has_paypwd || false,
            has_security_question: res.data.has_security_question || false
          }
        }
      }).catch(() => {})
    },
    goTo(idx) {
      this.$router.push({ path: '/security', query: { active: String(idx) } }).catch(() => {})
    },
    copyUsername() {
      if (!this.userInfo.username) return;
      const input = document.createElement('input');
      input.value = this.userInfo.username;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast && this.$toast('已复制');
    },
    focusPwd(field) {
      if (field === 2 && this.pwd1.length < 6) {
        this.warningMsg = '提现密码不能为空';
        field = 1;
      } else if (field === 1) {
        this.warningMsg = '';
      }
      this.currentField = field;
      this.keyboardVisible = true;
    },
    checkPwdRule(pwd) {
      if (pwd.length !== 6) return false;
      // 6个相同数字
      if (/^(\d)\1{5}$/.test(pwd)) return true;
      // 连续递增 012345 123456
      let asc = true;
      for (let i = 1; i < 6; i++) {
        if (pwd.charCodeAt(i) - pwd.charCodeAt(i - 1) !== 1) { asc = false; break; }
      }
      if (asc) return true;
      // 连续递减 654321
      let desc = true;
      for (let i = 1; i < 6; i++) {
        if (pwd.charCodeAt(i) - pwd.charCodeAt(i - 1) !== -1) { desc = false; break; }
      }
      if (desc) return true;
      return false;
    },
    onKey(n) {
      const field = this.currentField === 1 ? 'pwd1' : 'pwd2';
      if (this[field].length < 6) {
        this[field].push(String(n));
        this.$set(this, field, [...this[field]]);
        // 第一个框填满6位时，检查规则并自动跳转到第二个框
        if (this.currentField === 1 && this.pwd1.length === 6) {
          if (this.checkPwdRule(this.pwd1.join(''))) {
            this.warningMsg = '不能是6个相同或连续数字';
          }
          this.currentField = 2;
        }
      }
    },
    onBackspace() {
      const field = this.currentField === 1 ? 'pwd1' : 'pwd2';
      if (this[field].length > 0) {
        this[field].pop();
        this.$set(this, field, [...this[field]]);
        if (this.currentField === 1) {
          this.warningMsg = '';
        }
      }
    },
    handleSubmit() {
      switch (this.active) {
        case 5: // 提现密码
          this.submitPayPassword();
          break;
        case 3: // 登录密码
          this.submitLoginPassword();
          break;
        case 0: // 手机
          this.submitPhone();
          break;
        case 1: // 邮箱
          this.submitEmail();
          break;
        case 2: // 验证器
          this.submitGoogle();
          break;
        case 6: // 密保问题
          this.submitSecret();
          break;
        default:
          this.$toast && this.$toast('提交成功');
          break;
      }
    },
    submitPayPassword() {
      const p1 = this.pwd1.join('');
      const p2 = this.pwd2.join('');
      if (p1.length !== 6) {
        this.$toast && this.$toast('请设置完整的提现密码');
        return;
      }
      if (p2.length !== 6) {
        this.$toast && this.$toast('请确认提现密码');
        return;
      }
      if (p1 !== p2) {
        this.$toast && this.$toast('两次密码输入不一致');
        return;
      }
      if (this.checkPwdRule(p1)) {
        this.warningMsg = '不能是6个相同或连续数字';
        return;
      }
      // 调用新接口设置/修改提现密码（仅需新密码）
      this.$apiFun.post('/api/editPayPasswordNew', {
        paypassword: p1
      }).then(res => {
        if (res.code === 200) {
          this.$toast && this.$toast('设置成功');
          this.keyboardVisible = false;
          this.pwd1 = [];
          this.pwd2 = [];
          this.loadUserInfo(); // 刷新用户信息
          this.$router.back();
        } else {
          this.$toast && this.$toast(res.msg || '设置失败');
        }
      }).catch(() => {
        this.$toast && this.$toast('网络错误');
      });
    },
    submitLoginPassword() {
      // 验证
      if (!this.newPwd) {
        this.$toast && this.$toast('请输入新密码');
        return;
      }
      if (!this.hasLowercase || !this.hasUppercase || !this.hasNumber || !this.hasLength) {
        this.$toast && this.$toast('密码需包含大小写字母、数字，且6-16位');
        return;
      }
      if (!this.confirmPwd) {
        this.$toast && this.$toast('请再次输入新密码');
        return;
      }
      if (this.newPwd !== this.confirmPwd) {
        this.$toast && this.$toast('两次密码输入不一致');
        return;
      }
      // 调用新接口修改登录密码（仅需新密码）
      this.$apiFun.post('/api/editPasswordNew', {
        password: this.newPwd
      }).then(res => {
        if (res.code === 200) {
          this.$toast && this.$toast('修改成功');
          this.newPwd = '';
          this.confirmPwd = '';
          this.$router.back();
        } else {
          this.$toast && this.$toast(res.msg || '修改失败');
        }
      }).catch(() => {
        this.$toast && this.$toast('网络错误');
      });
    },
    sendCode() {
      if (this.codeSending || this.codeCountdown > 0) return;
      const mobile = (this.phoneInput || '').replace(/\D/g, '');
      if (!mobile) {
        this.$toast && this.$toast('请输入手机号');
        return;
      }
      if (!/^1\d{10}$/.test(mobile)) {
        this.$toast && this.$toast('请输入正确的11位手机号');
        return;
      }
      this.codeSending = true;
      this.$apiFun.post('/api/sendSmsCode', {
        phone: mobile,
        scene: 'bindphone'
      }).then(res => {
        this.codeSending = false;
        if (res.code === 200) {
          this.$toast && this.$toast('验证码已发送');
          this.startCountdown();
        } else {
          this.$toast && this.$toast(res.message || res.msg || '发送失败');
        }
      }).catch(() => {
        this.codeSending = false;
        this.$toast && this.$toast('网络错误');
      });
    },
    startCountdown() {
      this.codeCountdown = 60;
      this.codeBtnText = '60s';
      this.codeTimer = setInterval(() => {
        this.codeCountdown--;
        if (this.codeCountdown <= 0) {
          clearInterval(this.codeTimer);
          this.codeBtnText = '获取验证码';
        } else {
          this.codeBtnText = this.codeCountdown + 's';
        }
      }, 1000);
    },
    submitPhone() {
      const mobile = (this.phoneInput || '').replace(/\D/g, '');
      const code = (this.phoneCode || '').trim();
      if (!mobile) {
        this.$toast && this.$toast('请输入手机号');
        return;
      }
      if (!/^1\d{10}$/.test(mobile)) {
        this.$toast && this.$toast('请输入正确的11位手机号');
        return;
      }
      if (!code) {
        this.$toast && this.$toast('请输入验证码');
        return;
      }
      this.$apiFun.post('/api/bindPhone', {
        phone: mobile,
        code: code
      }).then(res => {
        if (res.code === 200) {
          this.$toast && this.$toast('绑定成功');
          this.phoneInput = '';
          this.phoneCode = '';
          this.loadUserInfo();
          this.$router.back();
        } else {
          this.$toast && this.$toast(res.message || res.msg || '绑定失败');
        }
      }).catch(() => {
        this.$toast && this.$toast('网络错误');
      });
    },
    submitEmail() {
      this.$toast && this.$toast('邮箱绑定功能待开发');
    },
    submitGoogle() {
      this.$toast && this.$toast('Google验证器绑定功能待开发');
    },
    submitSecret() {
      if (!this.selectedQuestion) {
        this.$toast && this.$toast('请选择密保问题');
        return;
      }
      if (!this.securityAnswer) {
        this.$toast && this.$toast('请输入密保答案');
        return;
      }
      if (!this.securityAnswerConfirm) {
        this.$toast && this.$toast('请再次输入密保答案');
        return;
      }
      if (this.securityAnswer !== this.securityAnswerConfirm) {
        this.$toast && this.$toast('两次答案输入不一致');
        return;
      }
      this.$apiFun.post('/api/editSecurityQuestion', {
        question: this.selectedQuestion,
        answer: this.securityAnswer
      }).then(res => {
        if (res.code === 200) {
          this.$toast && this.$toast('设置成功');
          this.selectedQuestion = '';
          this.securityAnswer = '';
          this.securityAnswerConfirm = '';
          this.loadUserInfo();
          this.$router.back();
        } else {
          this.$toast && this.$toast(res.msg || '设置失败');
        }
      }).catch(() => {
        this.$toast && this.$toast('网络错误');
      });
    }
  }
}
</script>

<style scoped>
.security-page {
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
  padding-bottom: 1.5rem;
}

.security-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem 0.3rem;
  background: #1a1a1a;
  border-bottom: 1px solid #2a2a2a;
}

.header-back {
  width: 0.6rem;
  cursor: pointer;
}

.header-title {
  font-size: 0.4rem;
  font-weight: bold;
  color: #fff;
}

.header-placeholder {
  width: 0.6rem;
}

/* 安全中心列表 */
.security-list {
  padding: 0.2rem 0;
  margin: 0 0.3rem;
}

.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.35rem 0.3rem;
  background: #1a1a1a;
  border-bottom: 1px solid #222;
  cursor: pointer;
}

.list-item-gap {
  margin-bottom: 0.25rem;
}

.list-item:first-child {
  border-radius: 0.15rem 0.15rem 0 0;
}

.list-item:last-child {
  border-bottom: none;
  border-radius: 0 0 0.15rem 0.15rem;
}

.item-left {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}

.icon-circle {
  width: 0.5rem;
  height: 0.5rem;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.item-icon {
  flex-shrink: 0;
}

.item-name {
  font-size: 0.32rem;
  color: #fff;
}

.red-dot {
  width: 0.15rem;
  height: 0.15rem;
  background: #ff5252;
  border-radius: 50%;
  flex-shrink: 0;
}

.item-right {
  display: flex;
  align-items: center;
  gap: 0.15rem;
}

.item-value {
  font-size: 0.32rem;
  color: #999;
}

.copy-icon {
  cursor: pointer;
}

.item-status {
  font-size: 0.3rem;
  color: #666;
}

.item-status.status-active {
  color: #d1ae52;
}

.arrow-icon {
  flex-shrink: 0;
}

/* 表单页 */
.tab-content {
  padding: 0.3rem;
}

.form-subtitle {
  font-size: 0.3rem;
  color: #999;
  margin-bottom: 0.3rem;
}

.security-tip-text {
  text-align: center;
  color: #00e676;
  font-size: 0.32rem;
  margin-bottom: 0.4rem;
}

/* 密码强度提示 */
.pwd-strength {
  margin-top: 0.15rem;
  font-size: 0.24rem;
  display: flex;
  align-items: center;
  gap: 0.15rem;
  flex-wrap: wrap;
}

.strength-label {
  color: #999;
  white-space: nowrap;
}

.strength-bar {
  display: flex;
  gap: 0.08rem;
  flex: 1;
  min-width: 1.5rem;
}

.strength-item {
  flex: 1;
  height: 0.05rem;
  background: #333;
  border-radius: 0.03rem;
  transition: background 0.3s;
}

.strength-item.active {
  background: #d1ae52;
}

.strength-tips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.15rem;
  width: 100%;
  margin-top: 0.1rem;
}

.strength-tips .tip {
  color: #666;
  position: relative;
  padding-left: 0.45rem;
}

.strength-tips .tip::before {
  content: '×';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0.35rem;
  height: 0.35rem;
  background: #ff5252;
  border-radius: 50%;
  color: #fff;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.35rem;
  box-sizing: border-box;
}

.strength-tips .tip.pass {
  color: #00e676;
}

.strength-tips .tip.pass::before {
  content: '✓';
  background: #00e676;
}

.security-form .form-item {
  margin-bottom: 0.3rem;
}

.security-form .form-label {
  display: block;
  font-size: 0.32rem;
  color: #ccc;
  margin-bottom: 0.2rem;
}

.security-form .form-input {
  width: 100%;
  padding: 0.25rem 0.3rem;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.1rem;
  color: #fff;
  font-size: 0.32rem;
  outline: none;
  box-sizing: border-box;
}

.security-form .form-input::placeholder {
  color: #666;
}

.security-form .form-input:focus {
  border-color: #d1ae52;
}

.security-form .form-input.with-icon {
  padding-left: 0.8rem;
  padding-right: 0.9rem;
}

.security-form .form-item-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.security-form .form-item-row .form-label {
  font-size: 0.32rem;
  color: #ccc;
}

.eye-icon {
  position: absolute;
  right: 0.2rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}

.code-btn {
  padding: 0.15rem 0.3rem;
  background: transparent;
  border: 1px solid #d1ae52;
  border-radius: 0.1rem;
  color: #d1ae52;
  font-size: 0.28rem;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
}

.code-btn:disabled {
  border-color: #555;
  color: #666;
  cursor: not-allowed;
}

.input-row {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}

.input-row .input-flex {
  flex: 1;
  min-width: 0;
}

.input-with-icon {
  position: relative;
}

.input-with-icon .key-icon {
  position: absolute;
  left: 0.25rem;
  top: 50%;
  transform: translateY(-50%);
}

.pwd-inputs {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.1rem;
  margin-bottom: 0.3rem;
  width: 100%;
}

.pwd-eye-icon {
  cursor: pointer;
}

.pwd-inputs .pwd-box {
  width: 100%;
  height: 1.3rem;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.1rem;
  color: #fff;
  font-size: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pwd-inputs .pwd-box.active {
  border-color: #DFB372;
}

.pwd-inputs .pwd-box .dot {
  width: 0.2rem;
  height: 0.2rem;
  background: #fff;
  border-radius: 50%;
  display: block;
}

.warning-text {
  display: flex;
  align-items: flex-start;
  gap: 0.15rem;
  color: #ff5252;
  font-size: 0.28rem;
  line-height: 1.5;
  margin-bottom: 0.4rem;
}

.warning-text .warning-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.4rem;
  height: 0.4rem;
  background: #ff5252;
  color: #fff;
  border-radius: 50%;
  font-size: 0.24rem;
  font-weight: bold;
  flex-shrink: 0;
}

.select-wrapper {
  position: relative;
  margin-bottom: 0.3rem;
}

.select-wrapper .select-trigger {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  padding: 0.25rem 0.3rem;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.1rem;
  cursor: pointer;
}

.select-wrapper .select-text {
  flex: 1;
  font-size: 0.32rem;
  color: #d1ae52;
}

.select-wrapper .select-arrow {
  transition: transform 0.3s;
}

.select-wrapper .select-arrow.rotate {
  transform: rotate(180deg);
}

.select-wrapper .select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.1rem;
  z-index: 10;
  max-height: 4rem;
  overflow-y: auto;
}

.select-wrapper .select-option {
  padding: 0.25rem 0.3rem;
  font-size: 0.32rem;
  color: #999;
  cursor: pointer;
}

.select-wrapper .select-option:hover,
.select-wrapper .select-option.active {
  color: #d1ae52;
}

.bottom-btn {
  position: fixed;
  bottom: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
  padding: 0.3rem;
  background: #d1ae52;
  color: #000;
  text-align: center;
  font-size: 0.35rem;
  border-radius: 0.25rem;
  font-weight: normal;
  cursor: pointer;
}

/* 数字键盘遮罩层 */
.keyboard-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.keyboard-collapse-area {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 7.5rem;
  cursor: pointer;
  z-index: 1;
}

.keyboard-popup {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #1a1a1a;
  z-index: 2;
}

.keyboard-body {
  background: #1a1a1a;
  padding: 0.2rem;
  padding-bottom: 0.5rem;
}

.keyboard-row {
  display: flex;
  gap: 0.06rem;
  margin-bottom: 0.15rem;
}

.keyboard-key {
  flex: 1;
  height: 1.5rem;
  background: #222;
  border-radius: 0.08rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.45rem;
  color: #fff;
  cursor: pointer;
  user-select: none;
}

.keyboard-key:active {
  background: #333;
}

.keyboard-empty {
  background: #222;
  pointer-events: none;
}

.keyboard-delete {
  background: #222;
}
</style>



// WEBPACK FOOTER //
// src/components/view/security/security.vue